import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { H3 } from "../atomic/atoms/type/H3"
import { COLORS, TYPE } from "../../theme/styles/globals"
import { MODE } from "../contentful/globals"
import Button from "../atomic/atoms/input/button"

export default class Footer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Container mode="dark">
          <Text>
            <Accent>Like what you see?</Accent>
            <Title>
              Let's make
              <br />
              something
              <br />
              beautiful
            </Title>
            <a href="mailto:clients@slik.com.au">
              <Button mode="DARK" label="Become a client" />
            </a>
            <Address>Level 1<br/>91 Campbell St<br/>Surry Hills 2010<br/>Australia</Address>
            <Phone href="tel:0290992544">02 9099 2544</Phone>
          </Text>
        </Container>
        <End>
          <SVG
            x={0}
            y={0}
            viewBox="0 0 72 100"
            xmlSpace="preserve"
          >
            <path
              style={{ fill: COLORS.DARK_GREY_2 }}
              d="M.3 65.98C.9 83.1 13.59 97.14 30.1 99.83l.03-33.85H.3zM58.77 37.55l-28.6 62.29c1.85.3 3.74.45 5.67.45 19.65 0 35.58-15.92 35.58-35.57v-.01c0-10.91-4.93-20.64-12.65-27.16M71.42 34.31C70.82 17.19 58.13 3.15 41.62.46l-.03 33.85h29.83zM12.95 62.74L41.55.45C39.7.16 37.81 0 35.88 0 16.23 0 .31 15.92.3 35.57v.01c0 10.91 4.93 20.64 12.65 27.16"
            />
          </SVG>
        </End>
      </React.Fragment>
    )
  }
}

const Container = styled.section`
  width: 100%;
  height: auto;
  background-color: ${props =>
    props.mode === MODE.LIGHT ? `${COLORS.WHITE}` : `${COLORS.DARK_GREY_1}`};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 50px;
  padding-bottom: 50px;
  justify-content: center;
  align-items: center;

  ${up("md")} {
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 150px;
    padding-right: 150px;
    flex-direction: row;
    width: auto;
    height: 100vh;
    justify-content: center;
    align-items: center;
  }
`

const Text = styled.div``

const Accent = styled.p`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  display: block;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};

  ${up("md")} {
    &::before {
      content: " ";
      width: 80px;
      height: 1px;
      background-color: ${props =>
        props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
      display: inline-block;
      margin-right: 20px;
      transform: translate(0px, -3px);
    }
  }
`

const Title = styled(H3)`
  font-size: 42px;
  line-height: 42px;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  margin-top: 20px;

  ${up("sm")} {
    font-size: 48px;
    line-height: 48px;
    margin-bottom: 30px;
  }

  ${up("md")} {
    font-size: 72px;
    line-height: 72px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`

const End = styled.section`
  width: 100%;
  height: auto;
  background-color: ${props =>
    props.mode === MODE.LIGHT ? `${COLORS.WHITE}` : `${COLORS.DARK_GREY_1}`};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 50px;
  justify-content: center;
  align-items: center;

  ${up("md")} {
    padding-top: 0px;
    padding-bottom: 0px;
    flex-direction: row;
    width: 100px;
    height: 100vh;
    justify-content: center;
    align-items: center;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }
`

const SVG = styled.svg`

  width:60px;
  margin-bottom:30px;

  ${up("md")} {
    position: absolute;
    z-index: 1000;
    width: 28px;
    bottom: 20px;
    left: 28px;
    margin-bottom:0px;
  }
`

const Address = styled.p`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  line-height:12px;
  opacity:.5;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  margin-top:30px;
`

const Phone = styled.a`
  font-family: ${TYPE.MONO_FONT};
  text-transform: uppercase;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: 2px;
  line-height:12px;
  opacity:.5;
  color: ${props =>
    props.mode === "LIGHT" ? `${COLORS.BLACK}` : `${COLORS.WHITE}`};
  margin-top:20px;
  display:block;
`